
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import minMax from "dayjs/plugin/minMax"; // Import the minMax plugin
import dayOfYear from "dayjs/plugin/dayOfYear"; // Import the minMax plugin
import localizedFormat from "dayjs/plugin/localizedFormat"; // Import the minMax plugin
import isSameOrBefore from "dayjs/plugin/isSameOrBefore"; // Import the minMax plugin
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import relativeTime from "dayjs/plugin/relativeTime";
import isoWeek from "dayjs/plugin/isoWeek";
import customParseFormat from "dayjs/plugin/customParseFormat";
import quarterOfYear from "dayjs/plugin/quarterOfYear";


// Extend Day.js with the plugin
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(minMax);
dayjs.extend(dayOfYear);
dayjs.extend(localizedFormat);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(relativeTime);
dayjs.extend(isoWeek);
dayjs.extend(customParseFormat);
dayjs.extend(quarterOfYear);


export { dayjs };

export function isDayjs(obj: any): obj is dayjs.Dayjs {
    return dayjs.isDayjs(obj);
}

/**
 * The IANA zone a dayjs instance is bound to, or undefined for a plain local
 * one. moment exposed this as the no-argument m.tz(); dayjs's .tz() is only a
 * setter, and the timezone plugin keeps the name on an internal field with no
 * public getter, so reading it means reaching for $x.$timezone.
 */
export function timezoneNameOf(value: dayjs.Dayjs): string | undefined {
    return (value as any).$x?.$timezone;
}

/**
 * `a <= b` compared as whole instants.
 *
 * ONLY valid without a granularity. If you need "same day" or "before this
 * month", use a.isSameOrBefore(b, unit) - this deliberately takes no unit
 * parameter so that requirement cannot be expressed here by accident.
 *
 * Worth having because dayjs's isSameOrBefore is isSame() || isBefore(), and
 * each of those re-wraps its argument and builds startOf/endOf instances:
 * six Dayjs allocations per comparison, spent on argument coercion and
 * granularity support that a Dayjs-to-Dayjs instant test uses neither of.
 * dayjs's own comparison coerces through valueOf in the end, so this is the
 * same test with the ceremony removed, and about three times faster - which
 * the duration-counting loops feel.
 */
export function isAtOrBefore(a: dayjs.Dayjs, b: dayjs.Dayjs): boolean {
    return a.valueOf() <= b.valueOf();
}

